import { render, staticRenderFns } from "./ownerGoods.vue?vue&type=template&id=2acc3260&scoped=true&"
import script from "./ownerGoods.vue?vue&type=script&lang=js&"
export * from "./ownerGoods.vue?vue&type=script&lang=js&"
import style0 from "./ownerGoods.vue?vue&type=style&index=0&id=2acc3260&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc3260",
  null
  
)

export default component.exports